<!-- 表格外面搜索 -->

<template>
  <div>
    <template v-for="(item, index) in columns" :key="item.prop">
      <template v-if="item.type === 'dict'">
        <el-select
          :class="{ ml10: index > 0 && device === 'desktop' }"
          v-model="searchVal[item.prop]"
          style="width: 200px"
          filterable
          clearable
          :placeholder="`请选择${item.label}`"
        >
          <el-option
            v-for="item in getDictListByParentCode(item.dictKey)"
            :key="item.libraryCode"
            :label="item.libraryName"
            :value="item.libraryCode"
          />
        </el-select>
      </template>
      <template v-else-if="item.type === 'date'">
        <el-date-picker
          :class="{ ml10: index > 0 && device === 'desktop' }"
          v-model="searchVal[item.prop]"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD"
          unlink-panels
        />
      </template>
      <template v-else>
        <el-input
          :class="{ ml10: index > 0 && device === 'desktop' }"
          v-model="searchVal[item.prop]"
          style="width: 200px"
          :placeholder="`请输入${item.label}`"
          clearable
        />
      </template>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import useCacheStore from "@/store/modules/cache";
import useAppStore from "@/store/modules/app";

const device = computed(() => useAppStore().device);

const cacheStore = useCacheStore();
const { getDictListByParentCode } = cacheStore;
const props = defineProps({
  // 表格列配置
  columns: {
    type: Array,

    default: () => [],
  },
});

const searchVal = ref({});

const getSearchParams = () => {
  const reParams = {};
  Object.keys(searchVal.value).forEach((key) => {
    const val = searchVal.value[key];
    if (val && val !== "" && val !== 0 && val !== null) {
      const col = props.columns.find((item) => item.prop === key);
      if (col) {
        if (col.type === "date" && val instanceof Array) {
          reParams[key] = {
            column: key,
            querLogic: "between",
            start: val[0] + " 00:00:00",
            end: val[1] + " 23:59:59",
          };
        } else if (col.type === "dict") {
          reParams[key] = { column: key, querLogic: "eq", value: val };
        } else if (col?.whereSql) {
          reParams[key] = { column: key, querLogic: col?.whereSql, value: val };
        }
      }
    }
  });
  return reParams;
};
/**
 * 获取搜索条件文本
 */
const getSearchText = () => {
  const reParams = {};
  Object.keys(searchVal.value).forEach((key) => {
    const val = searchVal.value[key];
    if (val !== "" && val !== 0 && val !== null && val !== "") {
      reParams[key] = val;
    }
  });
  return reParams;
};

const resetSearch = () => {
  searchVal.value = {};
};

defineExpose({
  getSearchParams,
  getSearchText,
  resetSearch,
});
</script>

<style lang="scss" scoped></style>
